(()=>{
  const styleId='axion-v54-rear-polish-style';
  if(!document.getElementById(styleId)){
    const style=document.createElement('style');
    style.id=styleId;
    style.textContent=`
      .axv3 .axv3__field--rear-type{min-width:0;align-self:start}
      .axv3 .axv3__rear-type-pills{min-height:43px;align-items:center;gap:8px}
      .axv3 .axv3__rear-type-pills button{
        height:43px;min-width:84px;padding:0 16px;
        display:inline-flex;align-items:center;justify-content:center
      }
      .axv3 .axv3__tmr-note{
        margin:-4px 0 14px;font-size:12px;line-height:1.5;opacity:.72
      }
      .axv3 [data-action="tmr"]{
        position:relative;min-height:164px;height:100%;
        padding:17px 122px 17px 17px!important;
        display:flex;flex-direction:column;align-items:flex-start
      }
      .axv3 [data-action="tmr"] p{margin-bottom:0}
      .axv3 [data-action="tmr"] em{margin-top:auto;padding-top:14px}
      .axv3 .axv3__tmr-icon{
        position:absolute!important;right:16px!important;top:50%!important;
        width:92px!important;height:92px!important;object-fit:contain!important;
        border-radius:0!important;background:transparent!important;padding:0!important;
        border:0!important;box-shadow:none!important;pointer-events:none!important;
        transform:translateY(-50%)!important
      }
      .axv3 [data-action="tmr"][data-value="Ginfull"] .axv3__tmr-icon{
        transform:translateY(-50%) scale(1.02)!important
      }
      .axv3 [data-action="tmr"][data-value="GuliKit"] .axv3__tmr-icon{
        right:16px!important;
        transform:translateY(-50%)!important;
      }
      .axv3 [data-action="tmr"][data-value="K-Silver"] .axv3__tmr-icon{
        transform:translateY(-50%) scale(.98)!important
      }
      @media(max-width:700px){
        .axv3 [data-action="tmr"]{min-height:148px;padding:16px 104px 16px 16px!important}
        .axv3 .axv3__tmr-icon{width:78px!important;height:78px!important;right:13px!important}
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll('[data-axion-configurator][data-product-handle="axion-designer-ps5"]').forEach(root=>{
    if(root.dataset.axionRearPolish==='1')return;
    root.dataset.axionRearPolish='1';
    const workspace=root.querySelector('[data-workspace]');
    if(!workspace)return;

    const COPY={
      '2':{
        tag:'ESSENTIAL',
        description:'Due input posteriori configurabili per adattarsi alla tua impugnatura.'
      },
      '4':{
        tag:'COMPETITIVE',
        description:'Quattro input posteriori configurabili per adattarsi alla tua impugnatura.'
      }
    };

    let queued=false;
    function patchRear(){
      const stepLabel=workspace.querySelector('.axv3__stephead span')?.textContent||'';
      if(stepLabel.includes('STEP 01')){
        const stepCopy='Configura gli input posteriori in base alla tua impugnatura: scegli quantità, posizione, tipologia, colore e mappatura.';
        const stepText=workspace.querySelector('.axv3__stephead p');
        if(stepText&&stepText.textContent!==stepCopy)stepText.textContent=stepCopy;
      }

      Object.entries(COPY).forEach(([count,data])=>{
        const card=workspace.querySelector(`[data-action="set"][data-key="rearCount"][data-value="${count}"]`);
        if(!card)return;
        const tag=card.querySelector('small');
        const desc=card.querySelector('p');
        if(tag&&tag.textContent!==data.tag)tag.textContent=data.tag;
        if(desc&&desc.textContent!==data.description)desc.textContent=data.description;
      });

      workspace.querySelectorAll('.axv3__field > label').forEach(label=>{
        const field=label.closest('.axv3__field');
        const text=(label.textContent||'').trim();
        if(text==='Tipologia Bottoni'){
          field?.classList.add('axv3__field--rear-type');
          field?.querySelector('.axv3__pills')?.classList.add('axv3__rear-type-pills');
        }
      });
    }

    function queueRear(){
      if(queued)return;
      queued=true;
      queueMicrotask(()=>{queued=false;patchRear()});
    }

    const observer=new MutationObserver(queueRear);
    observer.observe(workspace,{childList:true,subtree:true});
    root.addEventListener('click',queueRear);
    root.addEventListener('change',queueRear);
    patchRear();
  });
})();

(()=>{
  const FOUR_DEFAULTS=[
    ['rearPosition4','Busters - Lower'],
    ['mapLeftHigh','Quadrato'],
    ['mapRightHigh','Triangolo'],
    ['mapLeftLow','Croce'],
    ['mapRightLow','Cerchio']
  ];

  document.querySelectorAll('[data-axion-configurator][data-product-handle="axion-designer-ps5"]').forEach(root=>{
    if(root.dataset.axionFourRearDefaults==='1')return;
    root.dataset.axionFourRearDefaults='1';
    const workspace=root.querySelector('[data-workspace]');
    if(!workspace)return;

    function applyDefault(index=0){
      if(root.dataset.axionEditMode==='1'||index>=FOUR_DEFAULTS.length)return;
      const [key,value]=FOUR_DEFAULTS[index];
      const select=workspace.querySelector(`[data-action="select"][data-key="${key}"]`);
      if(!select)return;
      if(select.value===value){
        queueMicrotask(()=>applyDefault(index+1));
        return;
      }
      select.value=value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      queueMicrotask(()=>applyDefault(index+1));
    }

    root.addEventListener('click',e=>{
      const four=e.target.closest('[data-action="set"][data-key="rearCount"][data-value="4"]');
      if(!four||root.dataset.axionEditMode==='1'||root.dataset.axionFourRearDefaultsApplied==='1')return;
      root.dataset.axionFourRearDefaultsApplied='1';
      queueMicrotask(()=>applyDefault(0));
    });
  });
})();

/* AXION — warm cart/edit preview cache; visible 3D is never touched */
(()=>{
  const ROOT_SELECTOR='[data-axion-configurator][data-product-handle="axion-designer-ps5"]';
  const PENDING_KEY='axionCartPreviewPending';
  const HOOK_KEY='axionCartPreviewWarmHook';
  const CART_PREVIEW_ORBIT='0deg 78deg 105%';
  const CACHE_DELAY=120;
  const states=new WeakMap();
  const waitFrame=()=>new Promise(resolve=>requestAnimationFrame(resolve));

  const stateFor=root=>{
    let state=states.get(root);
    if(state)return state;
    state={capture:null,captureSrc:'',readyPromise:null,renderPromise:null,cachedData:'',cachedSignature:'',timer:0};
    states.set(root,state);
    return state;
  };

  const signature=root=>{
    const payload=root.querySelector('.axv3__payload pre')?.textContent?.trim();
    if(payload)return payload;
    return [
      root.querySelector('[data-build-code]')?.textContent?.trim()||'',
      root.querySelector('[data-shell-name]')?.textContent?.trim()||'',
      root.querySelector('[data-rear-name]')?.textContent?.trim()||'',
      root.querySelector('[data-performance-name]')?.textContent?.trim()||''
    ].join('|');
  };

  const effectiveTarget=viewer=>{
    try{
      const target=viewer.getCameraTarget?.();
      if(target&&[target.x,target.y,target.z].every(Number.isFinite))return `${target.x}m ${target.y}m ${target.z}m`;
    }catch(_){}
    return viewer.getAttribute('camera-target')||'auto auto auto';
  };

  const copyRenderAttributes=(source,target)=>{
    ['environment-image','exposure','shadow-intensity','shadow-softness','tone-mapping','skybox-image'].forEach(name=>{
      const value=source.getAttribute(name);
      if(value==null)target.removeAttribute(name); else target.setAttribute(name,value);
    });
    target.setAttribute('interaction-prompt','none');
    target.removeAttribute('camera-controls');
    target.setAttribute('camera-target',effectiveTarget(source));
    target.setAttribute('camera-orbit',CART_PREVIEW_ORBIT);
    target.setAttribute('field-of-view',source.getAttribute('field-of-view')||'27deg');
  };

  const copyMaterials=(source,target)=>{
    const sourceMaterials=source.model?.materials||[];
    const targetMaterials=target.model?.materials||[];
    if(!sourceMaterials.length||!targetMaterials.length)return;
    const byName=new Map(targetMaterials.map(material=>[material.name,material]));
    sourceMaterials.forEach(sourceMaterial=>{
      const targetMaterial=byName.get(sourceMaterial.name);
      if(!targetMaterial||sourceMaterial.isLoaded===false||targetMaterial.isLoaded===false)return;
      const sourcePbr=sourceMaterial.pbrMetallicRoughness;
      const targetPbr=targetMaterial.pbrMetallicRoughness;
      const factor=sourcePbr?.baseColorFactor;
      if(targetPbr&&factor?.length===4){
        targetPbr.setBaseColorFactor?.([...factor]);
        if(Number.isFinite(sourcePbr.metallicFactor))targetPbr.setMetallicFactor?.(sourcePbr.metallicFactor);
        if(Number.isFinite(sourcePbr.roughnessFactor))targetPbr.setRoughnessFactor?.(sourcePbr.roughnessFactor);
      }
      if(factor?.length===4&&Number(factor[3])<0.01)targetMaterial.setAlphaMode?.('BLEND'); else targetMaterial.setAlphaMode?.('OPAQUE');
    });
  };

  const destroyCapture=state=>{
    if(state.timer){clearTimeout(state.timer);state.timer=0}
    state.capture?.remove();
    state.capture=null; state.captureSrc=''; state.readyPromise=null; state.renderPromise=null; state.cachedData=''; state.cachedSignature='';
  };

  const ensureCapture=async(root,source)=>{
    const state=stateFor(root);
    const src=source.currentSrc||source.getAttribute('src')||source.src;
    if(!src)throw new Error('Sorgente 3D non disponibile');
    if(state.capture&&state.captureSrc===src&&state.capture.loaded)return state.capture;
    if(state.capture&&state.captureSrc===src&&state.readyPromise)return state.readyPromise;
    if(state.captureSrc&&state.captureSrc!==src)destroyCapture(state);

    const rect=source.getBoundingClientRect();
    const capture=document.createElement('model-viewer');
    capture.setAttribute('loading','eager');
    capture.setAttribute('aria-hidden','true');
    capture.tabIndex=-1;
    Object.assign(capture.style,{position:'fixed',left:'0',top:'0',width:`${Math.max(320,Math.round(rect.width||640))}px`,height:`${Math.max(320,Math.round(rect.height||640))}px`,opacity:'0',pointerEvents:'none',zIndex:'-1',display:'block'});
    copyRenderAttributes(source,capture);
    document.body.appendChild(capture);
    state.capture=capture;
    state.captureSrc=src;
    state.readyPromise=new Promise((resolve,reject)=>{
      const timer=setTimeout(()=>reject(new Error('Timeout preview renderer')),4000);
      const done=()=>{clearTimeout(timer);resolve(capture)};
      const fail=()=>{clearTimeout(timer);reject(new Error('Preview renderer non disponibile'))};
      capture.addEventListener('load',done,{once:true});
      capture.addEventListener('error',fail,{once:true});
    }).catch(error=>{if(state.capture===capture)destroyCapture(state);throw error});
    capture.src=src;
    return state.readyPromise;
  };

  const renderPreview=async(root,source,force=false)=>{
    const state=stateFor(root);
    const wantedSignature=signature(root);
    if(!force&&state.cachedData&&state.cachedSignature===wantedSignature)return state.cachedData;
    if(state.renderPromise)return state.renderPromise;
    state.renderPromise=(async()=>{
      const capture=await ensureCapture(root,source);
      copyRenderAttributes(source,capture);
      copyMaterials(source,capture);
      capture.jumpCameraToGoal?.();
      if(capture.updateComplete&&typeof capture.updateComplete.then==='function')await capture.updateComplete;
      await waitFrame();
      await waitFrame();
      let dataUrl='';
      try{dataUrl=await Promise.resolve(capture.toDataURL('image/webp',.86))}catch(_){dataUrl=await Promise.resolve(capture.toDataURL('image/png'))}
      if(typeof dataUrl!=='string'||!dataUrl.startsWith('data:image/')||dataUrl.length<500)throw new Error('Anteprima 3D offscreen non valida');
      state.cachedData=dataUrl;
      state.cachedSignature=wantedSignature;
      if(signature(root)!==wantedSignature)window.setTimeout(()=>schedulePreview(root,source,0),0);
      return dataUrl;
    })().finally(()=>{state.renderPromise=null});
    return state.renderPromise;
  };

  const schedulePreview=(root,source,delay=CACHE_DELAY)=>{
    if(!source?.loaded)return;
    const state=stateFor(root);
    if(state.timer)clearTimeout(state.timer);
    state.timer=window.setTimeout(()=>{
      state.timer=0;
      if(!root.querySelector('.axv3__devcart-add'))return;
      renderPreview(root,source).catch(error=>console.warn('[AXION preview cache DEV] Precache non disponibile.',error));
    },delay);
  };

  const warmRenderer=(root,viewer)=>{
    if(!viewer?.loaded)return;
    ensureCapture(root,viewer).then(()=>schedulePreview(root,viewer,30)).catch(error=>console.warn('[AXION preview cache DEV] Renderer offscreen non disponibile.',error));
  };

  const installViewerHook=(root,viewer)=>{
    if(!viewer||viewer.dataset[HOOK_KEY]==='1'||typeof viewer.toDataURL!=='function')return;
    viewer.dataset[HOOK_KEY]='1';
    const originalToDataURL=viewer.toDataURL.bind(viewer);
    viewer.toDataURL=function(...args){
      if(root.dataset[PENDING_KEY]!=='1')return originalToDataURL(...args);
      const state=stateFor(root);
      const wantedSignature=signature(root);
      delete root.dataset[PENDING_KEY];
      if(state.cachedData&&state.cachedSignature===wantedSignature)return state.cachedData;
      return renderPreview(root,viewer).then(()=>{
        if(state.cachedSignature===wantedSignature)return state.cachedData;
        return renderPreview(root,viewer);
      });
    };
    viewer.addEventListener('load',()=>warmRenderer(root,viewer));
    if(viewer.loaded)warmRenderer(root,viewer);
  };

  const installRoot=async root=>{
    if(!root)return;
    stateFor(root);
    try{await customElements.whenDefined('model-viewer')}catch(_){}
    const hook=()=>{
      const viewer=root.querySelector('[data-axion-model-viewer]');
      installViewerHook(root,viewer);
      if(viewer?.loaded)schedulePreview(root,viewer);
    };
    hook();
    if(root.dataset.axionCartPreviewWarmObserver!=='1'){
      root.dataset.axionCartPreviewWarmObserver='1';
      const observer=new MutationObserver(hook);
      observer.observe(root,{childList:true,subtree:true,characterData:true});
      root.addEventListener('change',()=>{const viewer=root.querySelector('[data-axion-model-viewer]');if(viewer?.loaded)schedulePreview(root,viewer)},true);
      root.addEventListener('click',()=>{const viewer=root.querySelector('[data-axion-model-viewer]');if(viewer?.loaded)schedulePreview(root,viewer)},true);
      window.addEventListener('pagehide',()=>destroyCapture(stateFor(root)),{once:true});
    }
  };

  document.addEventListener('click',event=>{
    const button=event.target.closest('.axv3__devcart-add');
    if(!button)return;
    const root=button.closest(ROOT_SELECTOR);
    if(!root)return;
    root.dataset[PENDING_KEY]='1';
  },true);

  const installAll=()=>document.querySelectorAll(ROOT_SELECTOR).forEach(root=>installRoot(root));
  installAll();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',installAll,{once:true});
})();
